import { render, staticRenderFns } from "./storesHistories.vue?vue&type=template&id=016b64cf"
import script from "./storesHistories.vue?vue&type=script&lang=js"
export * from "./storesHistories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports